import { Button, LuIcon, Text } from "@overmap-ai/blocks"
import { selectProcedureStepById } from "@overmap-ai/core"
import { getRouteApi, Link } from "@tanstack/react-router"
import { memo } from "react"

import { ProcedureStepIcon } from "../../components/Icons/ProcedureStepIcon"
import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { BaseTopBar } from "../TopBars/BaseTopBar"

const routeApi = getRouteApi(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields",
)

export const ProcedureStepSettingsFieldsViewTopBar = memo(() => {
	const { procedureStepId } = routeApi.useParams()

	const procedureStep = useAppSelector(selectProcedureStepById(procedureStepId))!

	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields"
					to="/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId"
				>
					<Button>
						<LuIcon icon={modelIconMapping.arrowLeft} />
						<ProcedureStepIcon procedureStepId={procedureStep.uuid} />
						<Text>{procedureStep.name}</Text>
					</Button>
				</Link>
			}
		/>
	)
})
ProcedureStepSettingsFieldsViewTopBar.displayName = "ProcedureStepSettingsFieldsViewTopBar"
